import { stringify } from 'querystring';

import { env } from './env';

export const ROOT_API_URL = env.VITE_ROOT_API_URL;
export const MEDIA_API_URL = env.VITE_MEDIA_API_URL;
export const TRACE_URL = env.VITE_TRACE_URL;
export const ANALYTICS_URL = env.VITE_ANALYTICS_URL;

const ONE_ACCOUNT_AXA_CLIENT_ID = env.VITE_ONE_ACCOUNT_AXA_CLIENT_ID;
const ONE_ACCOUNT_AXA_REDIRECT_URI = env.VITE_ONE_ACCOUNT_AXA_REDIRECT_URI;
const ONE_ACCOUNT_AXA_OAUTH_URL = env.VITE_ONE_ACCOUNT_AXA_OAUTH_URL;
export const ONE_ACCOUNT_AXA_URL = `${ONE_ACCOUNT_AXA_OAUTH_URL}?${stringify({
  response_type: 'code',
  client_id: ONE_ACCOUNT_AXA_CLIENT_ID,
  redirect_uri: ONE_ACCOUNT_AXA_REDIRECT_URI,
  scope: 'openid email profile'
})}`;

const MICROSOFT_SIA_CLIENT_ID = env.VITE_MICROSOFT_SIA_CLIENT_ID;
const MICROSOFT_SIA_REDIRECT_URI = env.VITE_MICROSOFT_SIA_REDIRECT_URI;
const MICROSOFT_SIA_OAUTH_URL = env.VITE_MICROSOFT_SIA_OAUTH_URL;
export const MICROSOFT_SIA_URL = `${MICROSOFT_SIA_OAUTH_URL}?${stringify({
  response_type: 'code',
  client_id: MICROSOFT_SIA_CLIENT_ID,
  redirect_uri: MICROSOFT_SIA_REDIRECT_URI,
  scope: 'openid email profile'
})}`;
